import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import { roleHomePath } from '../lib/roleHomePath'

/**
 * View-as sessions must not stay on super-admin URLs (wrong nav + APIs).
 */
export function useViewAsRouteGuard() {
  const { userProfile, isViewingAsUser, loading } = useAuth()
  const location = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    if (loading || !userProfile || !isViewingAsUser) return
    if (!location.pathname.startsWith('/super-admin')) return
    navigate(roleHomePath(userProfile), { replace: true })
  }, [loading, userProfile, isViewingAsUser, location.pathname, navigate])
}
